<template>
  <div class="w-full">
    <div class="flex flex-col lg:flex-row w-full lg:h-[474px] gap-4">
      <!-- Imagen principal -->
      <div class="w-full h-3/4 aspect-[4/3] lg:h-full flex items-center justify-center">
        <img
          class="h-full w-full rounded-lg object-cover cursor-pointer"
          :src="images.length > 0 ? images[0].src : defaultImage"
          :alt="images.length > 0 ? (images[0].alt || 'Imagen de la propiedad') : 'Imagen por defecto'"
          @click="openModal(0)"
        >
      </div>
      <!-- Miniaturas -->
      <div class="w-full lg:w-1/4 h-[100px] lg:h-full">
        <div class="grid grid-cols-4 lg:grid-cols-1 lg:grid-rows-4 gap-4 h-[80px] lg:h-full">
          <div
            v-for="idx in 4"
            :key="idx"
            class="relative h-[100px] lg:h-full group"
          >
            <img
              class="h-full w-full rounded-lg object-cover cursor-pointer"
              :src="images[idx] ? images[idx].src : defaultImage"
              :alt="images[idx] ? (images[idx].alt || 'Miniatura de la propiedad') : 'Miniatura por defecto'"
              @click="images[idx] && openModal(idx)"
            >
            <!-- Overlay -->
            <template v-if="idx === 4 && images.length > 5">
              <div
                class="group absolute inset-0 bg-black bg-opacity-30 rounded-lg flex flex-col items-center justify-center pointer-events-none"
              >
                <span class="text-white text-3xl font-medium transform transition-transform duration-300 group-hover:scale-110">+{{ images.length - 5 }}</span>
                <span class="text-white text-xs font-medium mt-1 transform transition-transform duration-300 group-hover:scale-110">Ver más</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal del Carousel -->
    <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div class="relative bg-white rounded-lg shadow-lg max-w-full max-h-[80vh] flex flex-col items-center justify-center">
        <!-- Botón cerrar -->
        <button class="absolute top-2 right-2 z-10" @click="showModal = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="#FF4265"/><path stroke="#fff" stroke-width="2" stroke-linecap="round" d="M8 8l8 8M16 8l-8 8"/></svg>
        </button>
        <!-- Botón anterior -->
        <button class="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white bg-opacity-70 rounded-full p-2" @click="prevImage" v-if="images.length > 1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M15 19l-7-7 7-7" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <!-- Imagen principal en modal -->
        <img
          class="max-w-full max-h-[80vh] object-contain rounded"
          :src="images[selectedIndex]?.src || defaultImage"
          :alt="images[selectedIndex]?.alt || 'Imagen de la galería'"
        >
        <!-- Botón siguiente -->
        <button class="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white bg-opacity-70 rounded-full p-2" @click="nextImage" v-if="images.length > 1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
//import { FwbCarousel } from "flowbite-vue";

const props = defineProps({
  images: {
    type: Array,
    default: () => []
  },
  defaultImage: {
    type: String,
    default: () => require('@/assets/imgs/default.png')
  }
});

const selectedIndex = ref(0);
const showModal = ref(false);

function prevImage() {
  if (selectedIndex.value > 0) {
    selectedIndex.value--;
  } else {
    selectedIndex.value = props.images.length - 1;
  }
}
function nextImage() {
  if (selectedIndex.value < props.images.length - 1) {
    selectedIndex.value++;
  } else {
    selectedIndex.value = 0;
  }
}

function openModal(idx) {
  if (props.images[idx]) {
    selectedIndex.value = idx;
    showModal.value = true;
  }
}
</script> 